export default class ContactLensForm {
  productCode: string;
  eyesIdentical: boolean;

  leftEye: ContactLensEye;
  rightEye: ContactLensEye;

  constructor(productCode: string, eyesIdentical: boolean ) {
    this.productCode = productCode;
    this.eyesIdentical = eyesIdentical;
    this.leftEye = new ContactLensEye();
    this.rightEye = new ContactLensEye();
  }

}

export class ContactLensEye {
  quantity: number;
  rangeUid: string;
  groupUid: string;
  constructor() {
    this.quantity = 1;
  }
}
